<script setup lang="ts">
import { useCategoryGroupStore } from "@/stores/master/category-group-store";
import { useCategoryStore } from "@/stores/master/category-store";
import { mapOptionMultiselectWithAll } from "@/utils/helper";
import { ref, defineEmits } from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const categoryStore = useCategoryStore();
const groupCategoryStore = useCategoryGroupStore();
const listCategories = ref<any>();
const listGroupCategories = ref<any>([]);
const category = ref();
const groupCategory = ref();
const search = ref("");
const sortby = ref("");

const loadListCategory = async () => {
  const { success, message } = await categoryStore.dispatchGetCategories(1, 99);
  if (success) {
    listCategories.value = mapOptionMultiselectWithAll(
      await categoryStore.categories.items
    );
  }
};

const loadListGroupCategory = async (idCategory = "") => {
  let queryParam = "";
  if (idCategory != "" && idCategory != "All") {
    queryParam = "&category_id=" + idCategory;
  }
  const { success, message } =
    await groupCategoryStore.dispatchGetCategoryGroups(1, 99, queryParam);
  if (success) {
    listGroupCategories.value = mapOptionMultiselectWithAll(
      await groupCategoryStore.categoryGroups.items
    );
  }
};

loadListCategory();
loadListGroupCategory();

const emit = defineEmits(["searchByQuery"]);

const buildQuery = async () => {
  let queryTemp = "";

  if (search.value != "") {
    queryTemp = queryTemp + "&keyword=" + search.value;
  }

  if (
    (category.value != undefined ||
    groupCategory.value != "") &&
    category.value?.value != "All"
  ) {
    const { success } = await categoryStore.dispatchDetail(
      category.value?.value
    );
    const categoryCode = await categoryStore?.category?.data?.code;
    if (success && categoryCode) {
      queryTemp =
        queryTemp +
        "&category_code=" + categoryCode;
    }
  }

  if (
    category.value &&
    (groupCategory.value != undefined ||
    groupCategory.value?.value != "All")
  ) {
    const { success } = await groupCategoryStore.dispatchDetail(
      groupCategory.value?.value
    );
    const groupCategoryCode = await groupCategoryStore?.categoryGroup?.data?.code;
    if (success && groupCategoryCode) {
      queryTemp =
        queryTemp +
        "&group_category_code=" + groupCategoryCode;
    }
  }

  if (sortby.value != "") {
    queryTemp = queryTemp + "&sort_by=" + sortby.value.toLocaleLowerCase();
  }

  emit("searchByQuery", queryTemp);
};

const handleChooseCategory = async () => {
  groupCategory.value = "";
  await loadListGroupCategory(category.value?.value);
  buildQuery();
};
</script>

<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div class="">
        <h4 class="fs-16 fw-medium mb-sm-0">Filter</h4>

        <form class="default-src-form mt-3">
          <div class="d-sm-flex flex-wrap row">
            <div class="position-relative mb-2 mb-sm-0 col">
              <input
                type="text"
                class="form-control rounded-1"
                placeholder="Search here"
                v-model="search"
                @keyup="buildQuery"
              />
              <i
                class="material-symbols-outlined position-absolute top-50 start-0 translate-middle-y fs-18"
              >
                search
              </i>
            </div>
            <div class="col col-md-3">
              <vSelect
                :options="listCategories"
                name="category"
                v-model="category"
                placeholder="Choose Category"
                @close="handleChooseCategory"
              ></vSelect>
            </div>
            <div class="col col-md-5">
              <vSelect
                :options="listGroupCategories"
                name="groupCategory"
                v-model="groupCategory"
                placeholder="Choose Group Category"
                @close="buildQuery"
              ></vSelect>
            </div>
            <div class="col col-md-2">
              <div class="form-group">
                <div class="form-group position-relative">
                  <vSelect
                    v-model="sortby"
                    :options="['Name', 'Date']"
                    placeholder="Sort By"
                    @close="buildQuery"
                  ></vSelect>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
